import React from 'react'
import { Field, FastField } from 'formik'
import { TextField, Switch } from 'formik-material-ui';
import { FormControlLabel, MenuItem, TextareaAutosize, FormControl } from '@material-ui/core';
import { OptionType } from '../types/constants';
import { KeyboardDatePicker } from '@material-ui/pickers';

type UamTextFieldProps = {
    fastfield?: boolean,
    [k: string]: any,
}
export const UamTextField = ({ fastfield, ...props }: UamTextFieldProps) => {
    const Component = fastfield ? FastField : Field
    return (<Component type='text' {...props} component={TextField} />)
}

export const UamNumberField = ({ fastfield, ...props }: UamTextFieldProps) => {
    const Component = fastfield ? FastField : Field;
    return (<Component type='text' {...props} component={TextField} />)
}

export const UamTextAreaField = ({ fastfield, ...props }: UamTextFieldProps) => {
    const Component = fastfield ? FastField : Field
    return (<Component type='text' {...props} component={TextareaAutosize} />)
}

export const UamDateField = ({ fastfield, ...props }: UamTextFieldProps) => {
    const Component = fastfield ? FastField : Field
    return (<Component {...props} component={KeyboardDatePicker} InputLabelProps={{ shrink: true, }} />)
}

type UamSwitchFieldProps = {
    label: string,
    fastfield?: boolean,
    [k: string]: any,
}
export const UamSwitchField = ({label, fullWidth, fastfield, ...props}: UamSwitchFieldProps) => {
    const Component = fastfield ? FastField : Field
    return (
        <FormControl style={{flex: '1 1'}}>
            <FormControlLabel control={<Component component={Switch} {...props} />} label={label} />
        </FormControl>
    )
}

type UamSelectFieldProps = {
    options: OptionType[],
    fastfield?: boolean,
    [k: string]: any,
}
export const UamSelectField = ({options, fastfield, ...props}: UamSelectFieldProps) => {
    const Component = fastfield ? FastField : Field
    return (
        <Component select type='text' 
        variant="standard"
        helperText="Seleziona un'opzione"
        margin="normal"
        component={TextField}
        InputLabelProps={{ shrink: true, }}
        {...props}
        >
          {options.map(option => (
              <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Component>
    )
}

// type UamMultiSelectFieldProps = {
//     options: any[],
//     values: any[],
//     getLabel: (option: any) => string,
//     getValue: (option: any) => any,
//     fastfield?: boolean,
//     [k: string]: any,

// }
// export const UamMultiSelectField = ({options, values, getLabel, getValue, ...props}: UamMultiSelectFieldProps) => {
//     return (
//         <Autocomplete
//             options={options.map((option) => option.value)}
//             getOptionLabel={getLabel}
//             value={[]}
//             freeSolo
//             renderTags={(value: string[], getTagProps) => value.map((option: string, index: number) => (
//                     <Chip variant="outlined" label={getLabel(option)} {...getTagProps({ index })} />
//                 ))
//             }
//             renderInput={(params) => (
//                 <MuiTextField {...params} variant="filled" label="freeSolo" placeholder="Favorites" />
//                 )}
//             {...props}
//         />
//     )
// }

export default { 
    UamTextField,
    UamTextAreaField,
    UamSwitchField,
    UamSelectField,
}